import { LabeledSwitch } from "../../../v2/components/LabeledSwitch";

/**
 * Classic View / Enhanced View, the control that decides whether the Audience
 * Layer sits beside the player or over it.
 *
 * v1 FILE IMPORTING A v2 COMPONENT. The boundary test polices this direction
 * too, not just v2 reaching into `@/Pages`, `@/Common` and MUI: a v1 file may
 * only import from v2 if it is named in V1_ALLOWLIST, and this one is. The
 * list is how a switch point stays a deliberate, reviewed decision instead of
 * something that spreads file by file.
 *
 * It used to be MUI's Switch under about seventy lines of `sx` overrides that
 * existed to make it not look like MUI. Then it was the v2 Switch under its
 * own inline styling. That styling now lives in LabeledSwitch, because the
 * Home Feed / Away Feed toggle on the same page is the same control and
 * needed the same twenty lines.
 */
const CustomChangeButton = ({
  checked,
  setChecked,
}: {
  checked: boolean;
  setChecked: (next: boolean) => void;
}) => (
  <LabeledSwitch
    offLabel="Classic View"
    onLabel="Enhanced View"
    checked={checked}
    onCheckedChange={setChecked}
  />
);

export default CustomChangeButton;
